import { FC } from 'react';

import { NumberSignEnum } from '../../../../lib/enums';
import TradePriceCache from '../../../../lib/store-util/TradePriceCache';
import { getPriceColorByDirection } from '../../../../lib/util/ChartingHelpers';
import { formatCurrencyBySymbol } from '../../../../lib/util/DataHelpers';
import { INVALID_VALUE } from '../../../../lib/util/types';

import { Week52Row } from '../../Week52GainersAndLosers.types';

import styles from '../../Week52GainersAndLosers.module.scss';

const CHANGE_PERCENT_PRECISION = 2;

type Props = { item: Week52Row };

const PriceAndChange: FC<Props> = (props: Props): JSX.Element => {
  const { item } = props;
  const { lookupSymbol, currencySymbol, isEuropeanSymbol } = item;
  const { currentPrice, changePercent, direction } = TradePriceCache.use(lookupSymbol, 'SymbolTradeInfoCard');

  if (!item.lastPrice) {
    return <>{INVALID_VALUE}</>;
  }
  const color = getPriceColorByDirection(direction);

  return (
    <div
      className={styles.priceAndChangeWrapper}
    >
      <div>
        <span className={styles.lastPrice}>
          {formatCurrencyBySymbol(currentPrice ?? item.lastPrice, currencySymbol, { isEuropeanSymbol })}
        </span>
      </div>
      <div>
        <div className={styles.priceAndChangeContainer}>
          {
            currentPrice && (
              <span style={{ color }}>
                (
                {direction}
                {changePercent}
                )
              </span>
            )
          }
          {
            !currentPrice && INVALID_VALUE
          }
          <span className={item.changePercent < 0 ? styles.negative : styles.positive}>
            (
            {item.changePercent >= 0 && NumberSignEnum.Positive}
            {(item.changePercent).toFixed(CHANGE_PERCENT_PRECISION)}
            %)
          </span>
        </div>
      </div>
    </div>
  );
};

export default PriceAndChange;
